<template>
  <div class="home">
    <div class="app-download" v-if="isPhone">
      <div class="app-download-width">
        <img src="/static/img/logo_alpacaielts.png" alt="羊驼雅思" />
        <a href="https://winielts.com/appPageIelts/appDownload/appDownload.html"
          >立即下载</a
        >
      </div>
    </div>

    <Head :headerNum="0" class="head" />
    <div class="clear"></div>

    <div class="abs-ad" v-if="isShowAd">
      <img :src="isShowImgSrc" alt />
      <img
        src="/static/img/close2.png"
        alt
        @click="isShowAd = false"
        style="cursor: pointer"
      />
    </div>
    <div class="abs-background" v-if="isShowAd" @click="isShowAd = false"></div>

    <!-- banner start -->
    <div class="swiper-banner">
      <div class="swiper-container-banner">
        <div class="swiper-wrapper">
          <!-- <a
            class="swiper-slide"
            href="https://mp.weixin.qq.com/s/avERG8K8Ei_GYVPYScuG2A"
          >
            <img class="img_c1" src="/static/img/banner/7.png" alt="" />
          </a> -->
          <a
            class="swiper-slide"
            href="https://www.winielts.com/news/views/info/803"
          >
            <img class="img_c1" src="/static/img/banner/6.jpg" alt="" />
          </a>
          <div class="swiper-slide">
            <img class="img_c1" src="/static/img/banner/2.png" alt="" />
          </div>
        </div>
        <div class="next-btn">
          <button @click="swiper.slidePrev()" class="next-left">
            <img
              src="https://www.yangtuoedu.com/yuanhua/images/home/arrow_gray_l.png"
              alt=""
            />
          </button>

          <button @click="swiper.slideNext()" class="next-right">
            <img
              src="https://www.yangtuoedu.com/yuanhua/images/home/arrow_gray_r.png"
              alt=""
            />
          </button>
        </div>
        <div class="switcher">
          <div
            class="item"
            :class="{ activated: activeIndex === index }"
            @click="switcher(index)"
            v-for="(item, index) in 2"
            :key="item"
          ></div>
        </div>
      </div>
    </div>
    <div class="container banner">
      <div class="container-content">
        <div class="container-content-width" style="padding-top: 20px">
          <div class=" test test-course">
            <h2 class="container-title">优秀公开课</h2>
            <div class="container-content">
              <div class="container-content-width">
                <div class="test-card-container teacher-course">
                  <div
                    class="card-img"
                    v-for="(item, index) in courseData"
                    :key="index"
                  >
                    <a :href="`/openclass?id=${item.id}`" target="_blank">
                      <img :src="item.outsideUrl" :alt="item.title" />
                    </a>
                  </div>
                </div>
                <a href="/openclass" class="test-more" target="_blank"
                  >MORE >></a
                >
              </div>
            </div>
          </div>
          <div class="banner-top">
            <div class="banner-top-top">
              <img src="/static/img/jy.png" alt="机经" style="width: auto" />
              <h2>关于 <strong>机经</strong>，你可以这么用</h2>
            </div>
            <p>
              羊驼雅思老师团队精心整理近期高频机经，搭配使用精选的备考资料，分类练习，助力提分！
            </p>
          </div>
          <div class="banner-mid">
            <div
              id="banner-mid-l"
              class="banner-card banner-mid-left-card hover-blue"
            >
              <div class="banner-card-left" @click="goUrl('雅思真题练习')">
                <!--<a href="/scripture">-->
                <h2>雅思真题练习（剑雅+整理题库）</h2>
                <p class="mb-text">
                  剑桥雅思系列真题题库，还有羊驼整理题库实时更新，听说读写全项突破（附带参考答案），练真题，对答案，掌握考题动向！
                </p>
                <div class="banner-img-a">
                  <!--<img src="/static/img/icon_ex_go_1.png" alt="" style="width: auto" />-->
                  <a href="javascript:">去练习</a>
                </div>
                <!--</a>-->
              </div>
              <div class="banner-card-right">
                <p>
                  {{ new Date().getMonth() + 1 }}月{{
                    new Date().getDate()
                  }}日更新
                </p>
                <!-- <p class="right-p2" v-if="receiveList.datas">
                  {{ receiveList.datas.ielts_experience_questions }}
                  <span>人正在练习</span>
                </p> -->
              </div>
            </div>
            <div id="blue-card" class="banner-card banner-mid-left-card">
              <div
                class="banner-card-left"
                style="position: relative"
                @click="
                  goLocation(
                    'http://mp.weixin.qq.com/s?__biz=MzU3MTY4OTExOA==&mid=100000012&idx=1&sn=32d645784d73885575cdfbcaec850d93&chksm=7cdd10fd4baa99eba60881b139d80f10aaf26313c2c8939c3462057267d96a62b7d4a3e025f8#rd',
                    '本月考前点睛'
                  )
                "
              >
                <h2 style="color: #fff">
                  本月考前点睛
                  <span style="font-size: 16px; padding-left: 10px"
                    >{{ new Date().getMonth() + 1 }}月 附参考答案</span
                  >
                </h2>
                <p style="width: 330px; color: #fff" class="mb-text">
                  本月考试押题预测及参考答案！快考试的同学赶紧利用参考答案进行复习，早看早过！
                </p>
                <div class="no-before">
                  <img
                    class="no-before-img"
                    src="/static/img/icon_ex_go_2.png"
                    alt
                    style="width: auto"
                  />
                  <a
                    target="_blank"
                    href="http://mp.weixin.qq.com/s?__biz=MzU3MTY4OTExOA==&mid=100000012&idx=1&sn=32d645784d73885575cdfbcaec850d93&chksm=7cdd10fd4baa99eba60881b139d80f10aaf26313c2c8939c3462057267d96a62b7d4a3e025f8#rd"
                    style="color: #fff; margin-left: 2px"
                    rel="nofollow"
                  >
                    去领取
                  </a>
                </div>
                <!-- <div class="rt" style="position: absolute; right: 0; bottom: 0">
                  <p style="width: auto; color: #ffe463" v-if="receiveList.datas">
                    {{ receiveList.datas.ielts_high_frequency }}
                    <span style="color: #fff">人已读</span>
                  </p>
                </div> -->
                <img
                  class="hot"
                  src="/static/img/pic_rope_1.png"
                  alt
                  style="
                    position: absolute;
                    width: auto;
                    right: -32px;
                    top: -22px;
                  "
                />
              </div>

              <!--<div class="banner-card-right">-->
              <!--<p>543692 <span>人已领</span></p>-->
              <!--</div>-->
            </div>
          </div>
          <div class="banner-bottom banner-mid">
            <div
              class="banner-card media-card banner-mid-left-card hover-blue"
              style="width: 280px; height: 200px"
            >
              <div
                class="banner-card-left"
                style="position: relative"
                @click="
                  goLocation(
                    'https://mp.weixin.qq.com/s?__biz=MzUzNzcyMzg5NA==&mid=2247488426&idx=2&sn=d65efe3e8e41e12dda3b401bae7009a5&chksm=fae3c533cd944c25eb1096738d49a41f366729c23ccbb3a7ca0534b452c800cf8773d8aef19b&token=724045627&lang=zh_CN#rd',
                    '当日机经'
                  )
                "
              >
                <h2 style="font-size: 20px">
                  口语打卡
                  <span
                    style="font-size: 14px; color: #feaa0f; margin-left: 10px"
                    >1V1点评</span
                  >
                </h2>

                <p style="width: 240px; margin-bottom: 26px">
                  筛选当季口语题库真题，了解出题动向。老师帮你口语批改，针对词汇、发音、语法等多个维度，进行实时纠错。
                </p>
                <div class="banner-img-a">
                  <a
                    target="_blank"
                    href="http://mp.weixin.qq.com/s?__biz=MzU3MTY4OTExOA==&mid=100000016&idx=1&sn=4b51e0d6b2e8f7b81ad2fcfb7372d2df&chksm=7cdd10e14baa99f737872df139195728482917efacd2ee936d5cce2a7aa222dd0803629a84b6#rd"
                    rel="nofollow"
                  >
                    去参加
                  </a>
                </div>
                <!-- <div class="rt" style="position: absolute; right: 0; bottom: 0">
                  <p style="width: auto; color: #1376f8" class="tar" v-if="receiveList.datas">
                    {{ receiveList.datas.ielts_today_experience }}
                    <span style="color: #333">人已参加</span>
                  </p>
                </div> -->
                <img
                  src="/static/img/pic_rope_2.png"
                  class="new"
                  alt
                  style="
                    position: absolute;
                    width: auto;
                    right: -26px;
                    top: -20px;
                  "
                />
              </div>
            </div>
            <div
              class="banner-card media-card banner-mid-left-card hover-blue"
              style="width: 280px; height: 200px"
            >
              <div
                class="banner-card-left"
                style="position: relative"
                @click="
                  goLocation(
                    'http://mp.weixin.qq.com/s?__biz=MzU3MTY4OTExOA==&mid=100000017&idx=1&sn=08f1871ad4f51896c757ff69595e09d5&chksm=7cdd10e04baa99f6d6a02ff056a54dceebf83aad44f22a45424999744c8c329f901e5391aa79#rd',
                    '本周考场回忆'
                  )
                "
              >
                <h2 style="font-size: 20px">
                  本周考场回忆
                  <span
                    style="font-size: 14px; color: #feaa0f; margin-left: 10px"
                    >附参考答案</span
                  >
                </h2>
                <p style="width: 240px; margin-bottom: 26px">
                  相比市面上的部分机经，预测内容更多更快，还附带答案解析~
                </p>
                <div class="banner-img-a">
                  <a
                    target="_blank"
                    href="http://mp.weixin.qq.com/s?__biz=MzU3MTY4OTExOA==&mid=100000017&idx=1&sn=08f1871ad4f51896c757ff69595e09d5&chksm=7cdd10e04baa99f6d6a02ff056a54dceebf83aad44f22a45424999744c8c329f901e5391aa79#rd"
                    rel="nofollow"
                  >
                    可添加任意羊驼老师免费领取
                  </a>
                </div>
                <!-- <div class="rt" style="position: absolute; right: 0; bottom: 0">
                  <p style="width: auto; color: #1376f8" class="tar" v-if="receiveList.datas">
                    {{ receiveList.datas.ielts_weeks_experience }}
                    <span style="color: #333">人已领</span>
                  </p>
                </div> -->
              </div>

              <!--<div class="banner-card-right">-->
              <!--<p>543692 <span>人已领</span></p>-->
              <!--</div>-->
            </div>
            <!-- <div class="exam-card banner-card banner-mid-left-card" style="
                width: 600px;
                height: 200px;
                flex-direction: column;
                cursor: default;
              ">
              <div class="banner-card-top" style="position: relative">
                <h2>命中榜</h2>
              </div>
              <div class="swiper-container swiper-container-bang swiper-no-swiping">
                <ul class="banner-card-ul swiper-wrapper">
                  <li class="swiper-slide" v-for="(item, index) in examList" :key="index">
                    <img :src="item.icon" alt />
                    <p style="width: 80px">{{ item.nickName }}</p>
                    <i>{{ item.topicType }}</i>
                    <span>{{ item.topicTheme }}</span>
                    <p>{{ item.examinationRoom }}</p>
                    <span>{{ timeCom(item.examTime) }}</span>
                    <a href="javascript:">考过</a>
                  </li>
                </ul>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- banner end -->

    <!-- 在线练习与公开课 start -->
    <div class="container test">
      <h2 class="container-title">在线练习</h2>
      <div class="container-content">
        <div class="container-content-width">
          <div class="test-card-container">
            <div
              class="test-card"
              v-for="(item, index) in testCardData"
              :key="index"
              @click="goPush(item.route)"
            >
              <div class="card-top">
                <img
                  src="/static/img/pic_rope_3.png"
                  style="
                    position: absolute;
                    width: auto;
                    right: -7px;
                    top: -7px;
                  "
                  v-if="index === 0"
                />
                <img class="card-top-img" :src="item.img" :alt="item.title" />
                <h2>{{ item.title }}</h2>
              </div>
              <div class="card-content">
                <p>{{ item.content }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 在线练习与公开课 end -->

    <!--雅思APP start-->
    <div class="app-container container" v-if="!isPhone">
      <div class="container-arrow" style="height: 64px">
        <a
          href="javascript:"
          v-scroll-to="{
            el: '.app-container',
            container: 'body',
            duration: 300,
            easing: 'linear',
            offset: -50,
            force: true,
            cancelable: true,
            x: false,
            y: true
          }"
        >
          <img
            src="/static/img/arrow_adv.png"
            alt
            style="width: 12px; height: 6px"
          />
        </a>
      </div>
      <!-- 修改的地方 -->
      <div class="container-content">
        <div class="container-content-width">
          <!-- <ul class="app-ul">
            <li>
              <span>羊驼雅思 - APP</span>
              <p>
                集合雅思练习题库，雅思真题回忆，雅思题型技巧练习和剑雅4~13题库为核心功能，是你的专属雅思掌上老师。
              </p>
            </li>
            <li style="margin-left: 17px">
              <img src="/static/img/app_new.png" alt />
            </li>
            <li>
              <p>• 功能全新升级，打卡模式强势上线</p>
              <p>• 羊驼精选题库，不止于剑雅真题</p>
              <p>• 摆脱“哑巴英语”，口语考试不再无话可说</p>
              <p>• 独特精听系统，提分简单暴力</p>
              <p>• 讲师精准预测，高命中率，考前不慌乱</p>
            </li>
          </ul> -->
          <!-- 修改的地方 -->
          <ul class="banner_box">
            <li>
              <h2>羊驼雅思-APP</h2>
              <p class="title">
                集合剑桥雅思练习题库，雅思机经及答案解析，AI精听跟读，万人
                交流社区，斩单词的核心功能。
              </p>
              <div class="con-box">
                <p>
                  -海量题库：剑雅系列题库，历年考试真题，高分解析，视频带练
                  <br />
                  -精听跟读：超多跟读素材，实时测评打分，口语听力双进阶软件
                  <br />
                  -技巧微课：练逐阶常备的学习课程，细致到科目小知识点
                </p>
              </div>
              <div class="bottom">
                <img
                  src="/static/img/button_ielts_vip.png?yt-v=20230905"
                  alt="免费领取30"
                  class="img"
                  @click="wxModalShow = true"
                />
                <a
                  href="https://winielts.com/appPageIelts/appDownload/appDownload.html"
                  target="_blank"
                >
                  前往下载 <img src="/static/img/arrow_app_ielts.png" alt="" />
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <div class="app-container container" v-if="isPhone">
      <div class="container-content">
        <div class="container-content-width">
          <ul class="app-ul">
            <li style="margin-left: 17px">
              <img src="/static/img/pic_app_phone.png" alt />
            </li>
          </ul>
        </div>
      </div>
    </div> -->

    <!-- <div class="app-bottom-text" v-if="isPhone">
      <div class="app-bottom-text-l">
        <span>羊驼雅思 - APP</span>
        <p>
          集合雅思练习题库，雅思真题回忆，雅思题型技巧练习和剑雅4~13题库为核心功能，是你的专属雅思掌上老师。
        </p>
      </div>
      <div class="app-bottom-text-r">
        <p>• 功能全新升级，打卡模式强势上线</p>
        <p>• 羊驼精选题库，不止于剑雅真题</p>
        <p>• 摆脱“哑巴英语”，口语考试不再无话可说</p>
        <p>• 独特精听系统，提分简单暴力</p>
        <p>• 讲师精准预测，高命中率，考前不慌乱</p>
      </div>
    </div> -->

    <!--雅思APP end-->

    <!-- 统计 -->
    <!-- <div class="container statistics">
      <h2 class="container-title">
        羊驼学员来源与成本投入
        <br />数据占比统计
      </h2>
      <div class="container-content">
        <div class="container-content-width">
          <div class="statistics-img">
            <img src="/static/img/cirl1.png" class="statistics-img1" alt="羊驼学员来源" />
            <img src="/static/img/cirl2.png" class="statistics-img2" alt="成本投入数据占比统计" style="width: 444px" />
          </div>
        </div>
      </div>
    </div> -->
    <!-- 统计结束 -->

    <!-- 课程 start-->
    <div class="quality-course">
      <div class="container-title-2">羊驼IELTS <strong>课程</strong></div>
      <div class="container-title-3">在羊驼课堂，多方位跟踪学习效果</div>
      <div class="course-content">
        <!-- <div class="course-list list-2">
          <router-link
            :to="{ path: '/curriculum-detail', query: { id: item.id } }"
            class="c-item"
            v-for="(item, index) in qualityCourse"
            :key="index"
          >
            <img :src="item.img" :alt="item.name" />
            <div class="c-txt">
              <div class="c-name">{{ item.name }}</div>
              <div
                class="c-title"
                v-for="(item2, index2) in item.title"
                :key="index2"
              >
                {{ item2 }}
              </div>
            </div>
            <router-link
              class="c-more"
              :to="{ path: '/curriculum-detail', query: { id: item.id } }"
              >了解更多</router-link
            >
          </router-link>
        </div> -->
      </div>
    </div>
    <!-- <div class="container course" style="background-color: #fafafa">
      <div class="course-btn">
        <p>Course</p>
      </div>
      <h2 class="container-title" style="margin-top: 20px">
        羊驼雅思
        <strong>优质课程</strong>
      </h2>
      <p class="course-p">在羊驼雅思课堂，我们为每位考生量身定制学习计划，多方位跟踪学习效果</p>
      <div class="container-content">
        <div class="container-content-width">
          <div class="course-card-container">
            <div class="course-card" v-for="(item,index) in courseCardList" :key="index">
              <a :href="item.url" target="_blank">
                <div class="course-card-top">
                  <h2 class="course-card-top-btn" :style="courseColorCom(index)">{{item.btn}}</h2>
                  <h2 class="course-card-title">{{item.title}}</h2>
                </div>
                <div class="course-card-content">
                  <span>{{item.title2}}</span>
                  <p style="margin-top: 10px">{{item.content1}}</p>
                  <p>{{item.content2}}</p>
                  <p>{{item.content3}}</p>
                </div>
              </a>
            </div>
          </div>
          <a href="/course" class="course-more" target="_blank">MORE >></a>
        </div>
      </div>
    </div>-->
    <!-- 课程 end-->

    <!-- 报名 start-->
    <div class="container sign-up">
      <div class="container-arrow" v-if="!isPhone" style="height: 70px">
        <a
          href="javascript:"
          v-scroll-to="{
            el: '.sign-up',
            container: 'body',
            duration: 300,
            easing: 'linear',
            offset: -50,
            force: true,
            cancelable: true,
            x: false,
            y: true
          }"
        >
          <img
            src="/static/img/arrow_adv.png"
            alt
            style="width: 12px; height: 6px"
          />
        </a>
      </div>
      <h2 class="container-title" style="color: #fff">轻松应对，努力不白费</h2>
      <div class="container-content">
        <div class="container-content-width">
          <p class="sign-p">
            雅思教研团队为烤鸭提供个性化备考方案:
            <br />水平测试→制定学习计划(学习周期及学习任务)→跟班或1对1辅导学习→全程助教课后跟踪服务→
            <br />考前模考（考试策略指导）→考后服务
            <br />推荐配合使用羊驼雅思APP和PC练习网站、精选雅思学习资料
          </p>
          <div class="sign-btn-container">
            <!-- <a
              target="_blank"
              href="https://mp.weixin.qq.com/s?__biz=MzU3MTY4OTExOA==&mid=100002078&idx=1&sn=247815c53a471b488fb9e93bb8675e68&chksm=7cdd18ef4baa91f9684514849cbf6992c9a87b21a480223e668466ec34cd1fd3b437c935fb25#rd"
              rel="nofollow"
            >
              <p class="sign-btn-p">咨询课程</p>
            </a> -->
            <a
              target="_blank"
              href="https://ielts.etest.net.cn/"
              style="background: none; border: solid 2px #ffffff"
              rel="nofollow"
            >
              <p class="sign-btn-p" style="color: #fff; line-height: 46px">
                官方报名通道
              </p>
            </a>
          </div>
          <div class="sign-float">
            <ul class="slideInUp">
              <li>
                <img src="/static/img/adv_f-icon_1.png" alt="听力预判法" />
              </li>
              <li style="margin-bottom: 10px">
                <img src="/static/img/adv_f-icon_2.png" alt="写作逻辑分类法" />
              </li>
              <li>
                <img src="/static/img/adv_f-icon_3.png" alt="阅读定向狙击法" />
              </li>
              <li style="margin-top: 110px; margin-left: 40px">
                <img src="/static/img/adv_f-icon_4.png" alt="口语”5w”教学法 " />
              </li>
              <li style="margin-top: 0">
                <img src="/static/img/adv_f-icon_5.png" alt="口语逻辑创作法" />
              </li>
              <li style="margin-top: 120px">
                <img
                  src="/static/img/adv_f-icon_6.png"
                  alt="写作”十字”破题法"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 报名 end-->

    <!-- 顶尖教研-start-->
    <div
      class="list-courses clear courses-panel-height"
      style="margin-top: 200px"
    >
      <div class="containerIndex"></div>
      <h2 class="new-panel-title1 new-panel-title" style>羊驼IELTS教研团队</h2>
      <div class="courses-panel">
        <div class="containerIndex">
          <img
            class="teacher-mainUrl active-david"
            src="/static/img/david.png"
            alt="顶尖教研老师"
            v-show="teacherShow === 0"
          />
          <img
            class="teacher-mainUrl active-lin"
            src="/static/img/elle.png"
            alt="顶尖教研老师"
            v-show="teacherShow === 1"
          />
          <img
            class="teacher-mainUrl active-yangtuo"
            src="/static/img/pic_ielts_Cteacher.png"
            alt="顶尖教研老师"
            v-show="teacherShow === 2"
          />
          <img
            class="teacher-mainUrl active-yangtuo"
            src="/static/img/yangtuo.png"
            alt="顶尖教研老师"
            v-show="teacherShow === 3"
          />
          <img
            class="teacher-mainUrl active-jnc"
            src="/static/img/jnc.png"
            alt="顶尖教研老师"
            v-show="teacherShow === 4"
          />
          <div class="courses-teacher">
            <div class="teacher-msg active-david" v-show="teacherShow === 0">
              <div class="courses-teacher-name">
                <p>David</p>
                <span>澳洲国立大学 硕士学位</span>
              </div>
              <ul class="clear">
                <li class="active">口语</li>
                <li class="active">写作</li>
                <!-- <li class="active">阅读</li> -->
                <li>听力</li>
              </ul>
              <p class="clear courses-teacher-content">
                <span
                  >雅思、PTE听说读写技能四项老师，口语、写作讲师。多家教育机构教师培训师，从业至今，致力于雅思教学方法研究，课程包括口语“5W”教学法、写作“十字破题法”，擅长引导不同类型的学生，高分学生众多，深得学生青睐。</span
                >
              </p>
            </div>
            <div class="teacher-msg active-lin" v-show="teacherShow === 1">
              <div class="courses-teacher-name">
                <p>Elle老师</p>
                <span>香港理工大学传译与翻译 硕士学位</span>
              </div>
              <ul class="clear">
                <li class="active">口语</li>
                <li>写作</li>
                <!-- <li class="active">阅读</li> -->
                <li class="active">听力</li>
              </ul>
              <p class="clear courses-teacher-content">
                <span
                  >口语听力双项讲师多年成人英语口语教学心得，教学风格深入浅出，化繁为简，对雅思口语。听力学习及考试有深入浅出的理解。</span
                >
              </p>
            </div>
            <div class="teacher-msg active-kay" v-show="teacherShow === 2">
              <div class="courses-teacher-name">
                <p>Lin</p>
                <span>阿德莱德大学，硕士学位</span>
              </div>
              <ul class="clear">
                <li class="">口语</li>
                <li class="">写作</li>
                <li class="active">阅读</li>
                <li class="active">听力</li>
              </ul>
              <p class="clear courses-teacher-content">
                <span
                  >南澳大利亚硕士
                  澳大利亚留学、生活6年，多年雅思听力、阅读教学心得，熟悉考试规则、深谙广大中国考生的听力及阅读弱点。拥有“听力预判法”、“阅读定向狙击法”等四大教学法体系，技巧一针见血。不放过学生学习问题，有效提升学生应试以及日常英语交流能力。</span
                >
              </p>
            </div>
            <div class="teacher-msg active-yangtuo" v-show="teacherShow === 3">
              <div class="courses-teacher-name">
                <p>羊驼老师</p>
                <span>澳洲昆士兰大学 硕士</span>
              </div>
              <ul class="clear">
                <li class="active">口语</li>
                <li class="active">写作</li>
                <li class="active">阅读</li>
                <li class="active">听力</li>
              </ul>
              <p class="clear courses-teacher-content">
                <span
                  >羊驼教育创办人，以帮助学员通过考试为己任，深入研究过上万份成绩单及口语发音，总结雅思、PTE两大英语考试黄金法则，带领教研、产品技术团队研发出雅思机考仿真系统及APP，并供广大学生免费使用，总结羊驼口语逻辑法，切中雅思考生应试弱点，短期内有效突破高分障碍。</span
                >
              </p>
            </div>
            <!-- <div class="teacher-msg active-jnc" v-show="teacherShow === 4">
              <div class="courses-teacher-name courese-Jnc">
                <p>James Neil Cooper</p>
                <span class="info-Jnc">前雅思口语英籍考官</span>
              </div>
              <ul class="clear">
                <li class="active">口语</li>
                <li class="active">写作</li>
                <li>阅读</li>
                <li>听力</li>
              </ul>
              <p class="clear courses-teacher-content">
                <span>英国巴斯大学硕士学位，地道英音，25年雅思教学经验，其中7年雅思考官经验，深谙中国学生雅思学习及考试痛点，能帮助学生在口语考试中避免容易出现的错误，在写作上能够较快引导学生学会用西式文化和思维方式勾勒文章结构和内容，做到知己知彼而运筹帷幄。同时运用英式英语教学的方式,
                  轻松愉快地传授雅思考试实战技巧。</span>
              </p>
            </div> -->
            <div class="teacher-minImg">
              <ul>
                <li
                  @mouseover="isTeacherShow(0)"
                  :class="{ cur: teacherShow === 0 }"
                >
                  <a href="javascript:void(0);">
                    <div class="front">
                      <img
                        class="teacher-on"
                        src="/static/img/c_teacher_1-2.png"
                        alt="顶尖教研老师"
                      />
                    </div>
                    <div class="back">
                      <img
                        class="teacher-on"
                        src="/static/img/c_teacher_1-1.png"
                        alt="顶尖教研老师"
                      />
                    </div>
                    <span v-if="!isPhone">David</span>
                  </a>
                </li>
                <li
                  @mouseover="isTeacherShow(1)"
                  :class="{ cur: teacherShow === 1 }"
                >
                  <a href="javascript:void(0);">
                    <div class="front">
                      <img
                        class="teacher-on"
                        src="/static/img/c_teacher_2-1.png"
                        alt="顶尖教研老师"
                      />
                    </div>
                    <div class="back">
                      <img
                        class="teacher-on"
                        src="/static/img/c_teacher_2-1.png"
                        alt="顶尖教研老师"
                      />
                    </div>
                    <span v-if="!isPhone">Elle</span>
                  </a>
                </li>
                <li
                  @mouseover="isTeacherShow(2)"
                  :class="{ cur: teacherShow === 2 }"
                >
                  <a href="javascript:void(0);">
                    <div class="front">
                      <img
                        class="teacher-on"
                        src="/static/img/pic_ielts_c_th_3-2.png"
                        alt="顶尖教研老师"
                      />
                    </div>
                    <div class="back">
                      <img
                        class="teacher-on"
                        src="/static/img/pic_ielts_c_th_3-1.png"
                        alt="顶尖教研老师"
                      />
                    </div>
                    <span v-if="!isPhone">Lin</span>
                  </a>
                </li>
                <li
                  @mouseover="isTeacherShow(3)"
                  :class="{ cur: teacherShow === 3 }"
                >
                  <a href="javascript:void(0);">
                    <div class="front">
                      <img
                        class="teacher-on"
                        src="/static/img/c_teacher_3-2.png"
                        alt="顶尖教研老师"
                      />
                    </div>
                    <div class="back">
                      <img
                        class="teacher-on"
                        src="/static/img/c_teacher_3-2.png"
                        alt="顶尖教研老师"
                      />
                    </div>
                    <span v-if="!isPhone">羊驼老师</span>
                  </a>
                </li>
                <!-- <li
                  @mouseover="isTeacherShow(4)"
                  :class="{ cur: teacherShow === 4 }"
                >
                  <a href="javascript:void(0);">
                    <div class="front">
                      <img
                        class="teacher-on"
                        src="/static/img/c_teacher_4-2.png"
                        alt="顶尖教研老师"
                      />
                    </div>

                    <span v-if="!isPhone">James</span>
                  </a>
                </li> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="new-panel">
        <h2 class="new-panel-title new-panel-title2">优秀授课老师</h2>
        <ul>
          <li v-for="(item, index) in teacherList" :key="index">
            <img
              class="teacher-list-img"
              :src="item.img_url"
              alt="顶尖教研老师"
            />
            <p>{{ item.name }}</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 顶尖教研-end-->

    <!--媒体报道start-->
    <div class="container media-report">
      <h2 class="container-title">媒体报道</h2>
      <div class="container-content">
        <div class="container-content-width">
          <ul class="media-report-ul">
            <li v-for="(item, index) in 12" :key="index">
              <img :src="`/static/img/pic_m_${index + 1}.png`" alt />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--媒体报道end-->

    <!--底部- start -->
    <CommonFooter />
    <!--底部- end -->

    <div class="clear"></div>

    <!-- 右侧固定导航 -->
    <div class="fixed-nav" id="fixedNav">
      <a
        class="fixed-nav-item"
        href="https://www.yangtuoedu.com"
        target="_blank"
        onclick="_czc.push(['_trackEvent', '悬浮栏', '综合站首页链接']);"
      >
        <img
          class="icon_img"
          src="/static/img/2020-12-28/icon_logo.png"
          alt="羊驼雅思"
        />
      </a>
      <div
        class="fixed-nav-item"
        onclick="_czc.push(['_trackEvent', '悬浮栏', '领取福利点击']);"
        @click="wxModalShow = true"
      >
        <div class="item_icon fuli"></div>
        <p class="item_text">领取福利</p>
      </div>
      <div
        class="fixed-nav-item"
        onclick="_czc.push(['_trackEvent', '悬浮栏', '添加顾问点击']);"
        @click="wxModalShow = true"
      >
        <div class="item_icon guwen"></div>
        <p class="item_text">添加顾问</p>
      </div>
      <div
        class="fixed-nav-item"
        onclick="_czc.push(['_trackEvent', '首页', '课程咨询点击']);"
        @click="wxModalShow = true"
      >
        <div class="item_icon kecheng"></div>
        <p class="item_text">课程咨询</p>
      </div>
      <a
        class="fixed-nav-item"
        href="https://support.qq.com/products/60474"
        target="_blank"
        rel="nofollow"
      >
        <div class="item_icon fankui"></div>
        <p class="item_text">意见反馈</p>
      </a>
      <img
        class="backtop-icon"
        @click="backTop"
        src="/static/img/2020-12-28/icon_backtop.png"
        alt=""
      />
      <div class="expand_handle" id="expandHandle"></div>
    </div>

    <!-- wx二维码弹窗 -->
    <div class="modal" v-if="wxModalShow">
      <div class="mask"></div>
      <div class="modal-content">
        <img
          class="modal-close"
          src="/static/img/home-modal/icon_close.png"
          alt
          @click="wxModalShow = false"
        />
        <img
          class="modal-content-img"
          src="/static/img/home-modal/Pop-ups_ielts.png"
          alt
        />
        <div class="wx-modal-left-head">
          <h5>咨询可爱的羊驼顾问</h5>
          <p>沟通老师，领取资料包+免费课程</p>
        </div>
        <img
          class="modal-wx"
          src="/static/img/home-modal/wx-m6969421.jpg?yt-v=20230518"
          alt
        />
        <p class="wx-modal-foot-text">扫码回复“ <span>官网</span>”咨询</p>
        <ul class="wx-modal-right-list">
          <li>全科技巧视频课程合集</li>
          <li>剑雅1~15教材PDF&音频</li>
          <li>阅读满分同义替换词库</li>
          <li>雅思写作高分模板</li>
          <li>口语写作绝密预测</li>
        </ul>
      </div>
    </div>

    <!-- Seo -->
    <template v-for="item in 1019">
      <a
        v-if="item >= 6"
        :href="`http://www.winielts.com/info/${item}.html`"
        :key="item"
        v-show="false"
      ></a>
    </template>

    <div style="display:none">
      <a target="_blank" href="http://www.shdaipu.com">计量泵</a>
      <a target="_blank" href="http://www.hnpflxj.com">离心机</a>
      <a target="_blank" href="http://www.cdsony.com">成都索尼售后</a>
      <a target="_blank" href="http://www.tclwxcd.com">成都TCL空调维修电话</a>
      <a target="_blank" href="http://www.hzsfhs.com">杭州二手电脑回收</a>
      <a target="_blank" href="http://www.zheqiaomu.com">抗震支架</a>
      <a target="_blank" href="http://www.028sanyo.com">成都三洋空调维修电话</a>
      <a target="_blank" href="http://www.huadicd.com">成都华帝热水器维修</a>
      <a target="_blank" href="http://www.csswt.com">不锈钢水箱厂家</a>
      <a target="_blank" href="http://www.shzjrg.com">金属软管</a>
      <a target="_blank" href="http://www.rongping.org">党建</a>
      <a target="_blank" href="http://www.thbusway.com">密集型母线槽</a>
      <a target="_blank" href="http://www.fuwash.com">高空作业平台</a>
      <a target="_blank" href="http://szcxmx.com">APP开发公司</a>
      <a target="_blank" href="http://www.wfcrps.com">成品排水沟</a>
      <a target="_blank" href="http://www.lyyuanquan.com">不锈钢水箱</a>
      <a target="_blank" href="http://www.ledjgc.com">led显示屏</a>
      <a target="_blank" href="http://www.ksxydjx.com">共板法兰风管</a>
      <a target="_blank" href="http://www.winielts.com">雅思报名</a>
      <a target="_blank" href="http://www.aicogrooming.com">宠物美容学校</a>
    </div>
  </div>
</template>

<script>
import ajax from "./../../api/ajax";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import Head from "./../../components/Head";

import CommonFooter from "@/components/Footer/Footer.vue";

import moment from "moment";
import ClipboardJS from "clipboard";
export default {
  name: "home",
  data() {
    return {
      swiper: null,
      activeIndex: 0,
      value2: 0, //轮播图索引
      isLoading: false,
      url: "https://winielts.com",
      courseData: [],
      receiveList: {},
      examList: [],
      bannerData: [],
      teacherShow: 0,
      active: 0, //顶部选中状态
      isPhone: false,
      isShowApp: false,
      teacherList: [
        // { name: "Dave", img_url: "/static/img/n_teacher_l1-p1.png" },
        { name: "Jamie", img_url: "/static/img/n_teacher_l1-p2.png" },
        { name: "Harris", img_url: "/static/img/n_teacher_l1-p3.png" },
        { name: "Maggie", img_url: "/static/img/n_teacher_l1-p5.png" },
        { name: "Keven", img_url: "/static/img/n_teacher_l1-p6.png" },
        { name: "Sissy", img_url: "/static/img/n_teacher/n_teacher_l2-p4.png" },
        { name: "Vivian", img_url: "/static/img/n_teacher_l1-p11.png" },
        { name: "Pearl", img_url: "/static/img/n_teacher_l1-p12.png" },
        { name: "William", img_url: "/static/img/n_teacher_l1-p13.png" },
        { name: "Tiffani", img_url: "/static/img/n_teacher_l3-p2.png" }
      ],
      testCardData: [
        {
          img: "/static/img/icon_pra_1.png",
          title: "雅思机考",
          content:
            "羊驼教研团队精心筛选高频剑雅真题题库，考前测评，带你揭开机考神秘面纱~",
          route: "exerciselist"
        },
        {
          img: "/static/img/icon_pra_2.png",
          title: "雅思机经练习",
          content:
            "针对雅思听力以及阅读，羊驼精心整理考场机经新题，专项练习，突破考点难点~",
          route: "scripture"
        },
        {
          img: "/static/img/icon_pra_3.png",
          title: "剑雅精听/练习",
          content:
            "专项训练剑雅4~13听力题型，快放慢放倒回去放，花式练习搞定剑雅听力~",
          route: "listenlist"
        }
      ],
      isShowImgSrc: "",
      isShowWechat: false,
      isShowCollab: false,
      isShowDatum: false,
      isShowCrouse: false,
      isShowPhone: false,
      isShowAd: false,
      isShowTopScroll: false,
      qualityCourse: [
        {
          id: 1,
          name: "雅思展翼班",
          title: ["基础薄弱适用", "三阶段课程提升英语核心力"],
          img: "/static/img/ielts_1.png"
        },
        {
          id: 2,
          name: "全科训练营",
          title: ["魔鬼训练营", "1vs1式全程督学", "为你保驾护航!"],
          img: "/static/img/ielts_2.png"
        },
        {
          id: 3,
          name: "全科冲刺班",
          title: [
            "实用技巧集训",
            "全程小班直播互动",
            "将你的基本功转化成分数!"
          ],
          img: "/static/img/ielts_3.png"
        },
        {
          id: 4,
          name: "1V1规划班",
          title: [
            "针对弱项量身设置课程内容",
            "根据吸收程度调节授课节奏",
            "效率惊人的学习形式!"
          ],
          img: "/static/img/ielts_4.png"
        }
      ],
      courseCardList: [
        {
          btn: "全",
          title: "全科训练营",
          title2: "听说读写系统化攻破",
          content1: "魔鬼训练营",
          content2: "1vs1式全程督学",
          content3: "",
          url:
            "https://weidian.com/item.html?itemID=2679282187&pc=1&wfr=wx_wxh5&ifr=shopdetail&spider_token=1d9f"
        },
        {
          btn: "全",
          title: "全科冲刺班",
          title2: "时间短、提分高、强预测",
          content1: "实用的技巧集训",
          content2: "全程小班直播互动",
          content3: "提升基本功！",
          url:
            "https://weidian.com/item.html?itemID=2679800812&pc=1&wfr=wx_wxh5&ifr=shopdetail&spider_token=b69e"
        },
        {
          btn: "专",
          title: "讲师1V1定制",
          title2: "讲师入学评估，个性化定制",
          content1: "针对弱项量身设置课程内容",
          content2: "根据吸收程度调节授课节奏",
          content3: "",
          url:
            "https://weidian.com/item.html?itemID=2679783398&pc=1&wfr=wx_wxh5&ifr=shopdetail&spider_token=a5f3"
        }
      ],
      schoolData: [
        {
          id: 1,
          type: 1,
          city: "杭州",
          name: "杭州校区",
          wx: "YTpte13yun",
          wxCode: "/images/YTpte13yun.png",
          img: "/static/img/school_cover_hangzhou.jpg",
          Introduce:
            "羊驼教育杭州校区位于朝晖路182号国都发展大厦1号楼180A，有完善的自习室、班课教室、VIP教室以及线上授课的电脑机房学习室。为选择不同授课模式的同学提供了完善的配套服务。地理位置处于杭城中心商圈，距离1号线西湖文化广场站直线距离约500米，周边汇集了留学，移民，艺术教育等公司。"
        },
        {
          id: 2,
          type: 1,
          city: "南京",
          name: "南京校区",
          wx: "YTpte13yun",
          wxCode: "/images/YTpte13yun.png",
          img: "/static/img/school_cover_nanjing.png",
          Introduce:
            "羊驼教育南京校区位于南京市鼓楼区中山路99号，新街口核心CBD地段，地铁1号线和2号线双地铁口新街口站，辐射南京市各个区域，黄金地段，宇宙中心，教育资源集中，交通便利。我们以工匠精神打造专业出国留学语言培训，提供雅思线下课程培训服务，旨在承诺一个全新的海外求学心意之旅。我们通过提升英语基础、熟练掌握雅思考试技巧、大量针对性的模拟机考和真题实战，帮助学生们短期内有效通过考试。"
        },
        {
          id: 3,
          type: 1,
          city: "深圳",
          name: "深圳校区",
          wx: "YTpte13yun",
          wxCode: "/images/YTpte13yun.png",
          img: "/static/img/school_cover_shenzhen.png",
          Introduce:
            "羊驼深圳雅思校区位于深圳市南山区卫星大厦，毗邻深圳大学、腾讯及百度大厦，交通方便，周边设有科苑地铁站和公交站以及快速路；教学设备齐全，设有VIP教室以及班课教室。面授教师全部拥有海外名校学历，有经验丰富的助教老师全天在校区为学生答疑解惑，督促训练，致力于为学生的雅思考试保驾护航。"
        },
        {
          id: 4,
          city: "天津",
          type: 1,
          name: "天津校区",
          wx: "YTpte13yun",
          wxCode: "/images/YTpte13yun.png",
          img: "/static/img/school_cover_tianjin.png",
          Introduce:
            "羊驼雅思天津校区位于天津市和平区博联大厦，毗邻南开大学，天津大学，天津医科大学和天津广播电视台，交通便利，楼下有多条公交线路，临近有西康路和吴家窑地铁站；校区临近北京考场，设备完善，有VIP教室和VIP自习室，授课老师均为世界Top50名校毕业，我们相信顶级师资，顶级人才，羊驼天津校区圆你雅思高分梦。"
        },
        {
          id: 5,
          city: "郑州",
          type: 1,
          name: "郑州校区",
          wx: "YTpte13yun",
          wxCode: "/images/YTpte13yun.png",
          img: "/static/img/school_cover_zhengzhou.png",
          Introduce:
            "羊驼河南郑州校区位于郑州东区. 专业的教师团队，设施齐全，优雅的环境，交通生活便利（地铁5号线金水东路站，新田360商场，临近高铁东站，龙子湖大学城.）校区设有：VIP教室，自习室，小班课教室，拥有海外高学位的教师团队，外教，助教，全天候的为学生线上，线下解答问题，督促学生的学习巩固环节. 为广大学子解决语言难关，拿到心仪的offer！"
        }
      ],
      // footAdShow: true, // 底部广告条show
      wxModalShow: false //微信二维码弹窗show
    };
  },
  components: {
    Head,
    CommonFooter
  },
  provide() {
    return {};
  },
  computed: {
    courseColorCom() {
      return function(index) {
        switch (index) {
          case 0:
            return { background: "#1376f8" };
            break;
          case 1:
            return { background: "#53a4f4" };
            break;
          case 2:
            return { background: "#c2e5ff" };
            break;
        }
      };
    },
    timeCom(time) {
      return function() {
        return moment(time).format("YYYY-MM-DD");
      };
    }
  },
  methods: {
    switcher(index) {
      this.swiper.slideTo(index);
    },
    backTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    showToast(text) {
      if (window.toasting) return;
      window.toasting = true;
      var toastNode = document.createElement("p");
      toastNode.className = "yt-toast";
      toastNode.id = "toast-node";
      toastNode.innerText = text;
      document.body.appendChild(toastNode);
      setTimeout(function() {
        window.toasting = false;
        document.body.removeChild(toastNode);
      }, 1500);
    },
    // 点击复制链接
    clipboardCopy() {
      const that = this;
      var clipboard = new ClipboardJS(".copy-btn");
      clipboard.on("success", function(e) {
        that.showToast("已复制微信号至剪贴板");
        that.wxModalShow = false;
      });
      clipboard.on("error", function(e) {
        that.showToast("复制失败，请重新尝试！");
      });
    },
    func_str(item) {
      return JSON.stringify(item);
    },
    isShowAds(url, img) {
      // console.log(_czc)
      _czc.push(["_trackEvent", "首页", "弹窗"]);
      if (url) {
        window.open(url, "_blank");
      } else {
        this.isShowImgSrc = img;
        this.isShowAd = true;
      }
    },
    goUrl(type) {
      _czc.push(["_trackEvent", "首页", type]);
      this.$router.push({ name: "scripture" });
    },
    goLocation(url, type) {
      _czc.push(["_trackEvent", "首页", type]);
      window.open(url, "_blank");
    },
    goPush(route) {
      if (!this.isPhone) {
        this.$router.push({ name: route });
      } else {
        this.$Modal.warning({
          title: "提示",
          content: "移动端暂不支持该功能，请登录PC端体验"
        });
      }
    },
    documentWidth() {
      if (document.body.clientWidth <= 750) {
        this.isPhone = true;
      }
    },
    isTeacherShow(index) {
      this.teacherShow = index;
    },
    changeItem(index) {
      this.active = index;
    },
    switchTo(path) {
      this.$router.replace(path);
    },
    goScroll(event) {
      let top = 0;
      this.isPhone ? (top = 300) : (top = 680);
      const currentY =
        document.documentElement.scrollTop || document.body.scrollTop;
      scrollAnimation(currentY, top);
    },
    showApp(flag) {
      this.isShowApp = flag;
    }
  },
  async mounted() {
    this.$nextTick(() => {
      let _this = this;
      this.swiper = new Swiper(".swiper-container-banner", {
        autoplay: true, //等同于以下设置
        on: {
          slideChangeTransitionStart: function() {
            _this.activeIndex = this.activeIndex;
          }
        }
      });
    });
    !(function() {
      var handle = document.getElementById("expandHandle"),
        fixedNav = document.getElementById("fixedNav");
      handle.addEventListener("click", function() {
        var isHide = this.classList.contains("hide");
        if (isHide) {
          this.classList.remove("hide");
          fixedNav.classList.remove("hide");
        } else {
          this.classList.add("hide");
          fixedNav.classList.add("hide");
        }
      });
    })();

    this.$nextTick(() => {
      new Swiper(".swiper-container-school", {
        navigation: {
          nextEl: ".s-next",
          prevEl: ".s-prev"
        },
        slidesPerView: 5,
        spaceBetween: 20,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        loop: true
      });
    });
    this.documentWidth();
    const courseList = await ajax(
      this.url + "/api/course/listByIds",
      [83, 47, 53],
      "POST"
    );
    const receiveList = await ajax(this.url + "/api/experience/receive");
    const examList = await ajax(this.url + "/api/experience/pcGetExamList");
    const bannerList = await ajax(this.url + "/api/carouselFigure/list", {
      clientType: "ieltspc"
    });
    this.bannerData = bannerList.data;
    this.examList = examList.data;
    this.receiveList = receiveList.data;
    this.courseData = courseList.data.list;

    // for (let i = 0 ; i < 4 ; i++){
    //   this.courseData.push(courseList.data.list[i])
    //   console.log(courseList.data.list[i].id)
    // }
    this.isLoading = true;

    if (!window.__PRERENDER_INJECTED) {
      if (window.collectAd) {
        window.collectAd.init();
      }
    }
    this.$nextTick(() => {
      var mySwiper = new Swiper(".swiper", {
        direction: "vertical", // 垂直切换选项
        loop: true, // 循环模式选项
        pagination: {
          el: ".swiper-pagination"
        }
      });
    });
  },
  beforeDestroy() {
    if (window.collectAd) {
      window.collectAd.destroy();
    }
  },
  watch: {
    examList() {
      let h;
      !this.isPhone ? (h = 150) : (h = 99);
      this.$nextTick(() => {
        new Swiper(".swiper-container-bang", {
          direction: "vertical",
          slidesPerView: 3,
          autoplay: {
            disableOnInteraction: false,
            delay: 2000
          },
          height: h,
          loop: true // 循环模式选项
        });
      });
    },
    bannerData() {
      this.$nextTick(() => {
        new Swiper(".top-swiper-container", {
          direction: "vertical",

          // slidesPerView:,
          autoplay: {
            disableOnInteraction: false,
            delay: 4000
          },
          height: 32
          // loop: true, // 循环模式选项
          // on:{
          //   click(e){
          //     console.log(e)
          //   }
          // }
        });
      });
    }
  }
};
</script>

<style scoped lang="stylus">
@import './home.css';
@import './css/home-modal.styl';

.c-more {
  border-top: 1px solid #f2f2f2;
  padding: 10px 20px;
  display: block;
  font-family:"思源黑体";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #7d5fe6;
}

.c-title {
  font-family:"思源黑体";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #333333;
}

.c-name {
  font-family:"思源黑体";
  font-size: 20px;
  font-weight: 700;
  font-stretch: normal;
  letter-spacing: 4px;
  color: #333333;
  margin-bottom: 10px;
}

.c-txt {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
}

.course-list {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .c-item {
    width: 260px;
    background-color: #ffffff;
    box-shadow: 2px 4px 6px 0px rgba(0, 0, 0, 0.04);
    border-radius: 2.5px;
    cursor: pointer;
  }

  .card-img {
    transition: all 10s ease;
  }

  .card-img:hover {
    margin-top: -30px;
  }
}

.course-content {
  max-width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  padding: 10px 0;
}

.quality-course {
  padding: 40px 0 50px;
  background-color: #fbfaff;

  .container-title-2 {
    text-align: center;
    margin-bottom: 20px;
    font-family:"思源黑体";
    font-size: 27.9975px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 2.8px;
    color: #333333;
  }

  .container-title-3 {
    text-align: center;
    margin-bottom: 20px;
    font-family:"思源黑体";
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #666666;
  }
}

.s-next {
  position: absolute;
  right: -60px;
  z-index: 1;
}

.s-prev {
  position: absolute;
  left: -60px;
  z-index: 1;
}

.item-bottom {
  padding: 15px 10px;
}

.swiper-container-school {
  padding: 10px 0;
}

.school-name {
  font-family:"思源黑体";
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #510fa8;
  text-align: center;
  margin: 0 0 8px 0;
}

.school-wx {
  font-family:"思源黑体";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #999999;
  margin: 5px 0 0 0;
  text-align: left;
  width: 100%;
  display: block;
}

.school-d {
  font-family:"思源黑体";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 22px;
  letter-spacing: 0px;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
  text-align: left;
  height: 44px;
}

.school-item {
  background-color: #ffffff;
  border-radius: 6px;
  box-shadow: 6px 7.4px 12px -3px rgba(0, 0, 0, 0.05);
  cursor: pointer;
}

.school-class-offline {
  width: 100%;
  display: block;
  margin: 0 auto;
  text-align: center;
  background-color: #fafcfe;
  padding: 20px 0;

  .campusName-panel {
    width: 530px;
    max-width: 100%;
    overflow-x: auto;
    margin: 20px auto 0 auto;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    &>li {
      display: block;
      margin: 0 10px 12px 0;

      &>a {
        width: 72px;
        height: 30px;
        line-height: 30px;
        background-color: #cfc2ff;
        border-radius: 4px;
        font-family:"思源黑体";
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
        text-align: center;
        display: block;
        cursor: pointer;
      }

      &>a:hover {
        background-color: #7d5fe6;
        color: #ffffff;
      }
    }
  }

  >span.school-class-span {
    width: 64px;
    height: 32px;
    background-color: #dff8e4;
    border-radius: 16px;
    font-family:"思源黑体";
    font-size: 14px;
    color: #36cb4f;
    display: block;
    line-height: 32px;
    text-align: center;
    margin: 20px auto;
  }

  p.class-offline-title {
    font-family:"思源黑体";
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #510fa8;
  }

  p.class-offline-text {
    font-family:"思源黑体";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #666666;

    >span {
      display: block;
    }
  }
}

.abs-ad {
  width: 353px;
  height: 500px;
  z-index: 9;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  justify-content: space-between;

  img {
    width: auto;
  }
}

.abs-background {
  background: #000;
  opacity: 0.2;
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 8;
}

.app-download {
  background-color: rgb(242, 242, 242);
  z-index: 1000;
  position: fixed;
  width: 100%;
  top: 0;
  height: 64px;

  .app-download-width {
    height: 100%;
    width: 90%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
      height: 50px;
      width: 160px;
    }

    a {
      font-size: 14px;
      color: #fff;
      text-align: center;
      width: 120px;
      height: 40px;
      background-color: #2396ff;
      border-radius: 29.5px;
      line-height: 40px;
    }
  }
}

/* .head {
  position fixed
  top 0
  width 100%
  z-index 10
} */
.header-top-silde {
  width: 320px;
  height: 180px;
  border-radius: 8px;
  position: absolute;
  left: -152px;
  bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.header-right-silde1 {
  width: 197px;
  height: 206px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-around;
  left: 160px;
  bottom: -98px;
  z-index: 999;

  .silde-lef {
    height: 100%;

    img {
      width: 100%;
    }
  }
}

.header-right-silde {
  width: 380px;
  height: 249px;
  position: absolute;
  bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  right: -177px;
  z-index: 999;

  .silde-lef {
    height: 100%;

    img {
      width: 100%;
    }
  }
}

.container-arrow {
  display: flex;
  justify-content: center;
  width: 100%;
  position: relative;

  a {
    line-height: 35px;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 50%;
    display: inline-block;
    width: 138px;
    height: 35px;
    transform: rotate(180deg) translateX(50%);
    text-align: center;
    background: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'138\' height=\'35\' viewBox=\'0 0 138 35\'%3E%3Cpath fill=\'%23fff\' d=\'M 3.15027 34.4375C 1.74207 34.6025 0.68396 34.7266 0 35L 68.9982 35C 68.9982 35 68.9998 28.6387 69 19.5132C 69 20.7261 69.0001 21.8892 69.0001 22.9956L 69.0018 35L 138 35C 137.316 34.7266 136.258 34.6025 134.85 34.4375C 131.11 33.9995 124.903 33.2729 116.678 28.6875C 111.015 25.3901 106.523 20.9771 102.07 16.6025C 93.5474 8.23096 85.1685 -1.97984e-15 69.0018 3.55056e-31C 69.0006 5.271 69 10.4292 69 15.0952C 69 10.4287 68.9994 5.27148 68.9982 3.55056e-31C 52.8314 1.97986e-15 44.4526 8.23096 35.9302 16.6025C 31.4772 20.9771 26.985 25.3901 21.3221 28.6875C 13.0974 33.2729 6.88965 33.9995 3.15027 34.4375Z\'/%3E%3C/svg%3E");

    img {
      transform: rotate(180deg);
    }
  }
}

.container-title {
  font-size: 32px;
  color: #333;
  font-weight: normal;
  margin-top: 25px;
}

.container {
  width: 100%;
  text-align: center;
}

.container-content-width {
  width: 1200px;
  margin: 0 auto;
}

/* 顶部 banner */
.top-banner-scroll {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 32px;
  background-color: #2483f7;
  overflow: hidden;
  box-shadow: 0px 2px 16px 0px rgba(31, 82, 173, 0.08);
  border-radius: 8px;

  .top-banner-scroll-flex {
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
    align-items: center;
    width: 96%;
    height: 32px;
    overflow: hidden;
  }

  .top-banner-scroll-flex img {
    cursor: pointer;
  }

  .top-banner-scroll-flex p {
    color: #fff;
  }
}

/* banner */
.banner-card-ul {
  width: 100%;
  margin: 0 auto;
  height: 150px;

  /* overflow-y: hidden */
  li {
    display: flex;
    height: 50px;
    align-items: center;

    /* justify-content: space-between */
    i {
      width: 30px;
      height: 16px;
      border-radius: 2px;
      border: solid 1px #1376f8;
      font-size: 12px;
      color: #1376f8;
      font-style: normal;
      line-height: 16px;
      margin-left: 10px;
    }

    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap; // 文本不换行，这样超出一行的部分被截取，显示...
      width: 160px;
      text-align: left;
      padding-left: 10px;
    }

    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap; // 文本不换行，这样超出一行的部分被截取，显示...
      width: 80px;
      text-align: left;
      margin-left: 16px;
      font-size: 12px;
      color: #808080;
    }

    img {
      height: 36px;
      width: 36px;
      border-radius: 50%;
    }
  }
}

.banner-card-top {
  height: 50px;
  width: 90%;
  margin: 0 auto;
  border-bottom: 1px solid #f2f2f2;
  line-height: 50px;

  h2 {
    color: #1376f8;
    font-size: 18px;
    font-weight: normal;
    text-align: left;
  }
}

.banner {
  .banner-top {
    padding-top: 25px;

    .banner-top-top {
      display: flex;

      h2 {
        font-size: 24px;
        font-weight: normal;
        color: #333;
        margin-left: 30px;
      }
    }

    p {
      text-align: left;
      margin-left: 67px;
      /* width 500px */
      line-height: 26px;
    }
  }

  #blue-card {
    width: 380px;
    height: 200px;
    /* autoprefixer: off */
    background: linear-gradient(left, #1376f8, #53a4f4);
    /* autoprefixer: on */
    background: -o-linear-gradient(left, #1376f8, #53a4f4);
    background: -moz-linear-gradient(left, #1376f8, #53a4f4);
    background: -webkit-linear-gradient(left, #1376f8, #53a4f4);
  }

  .hover-blue:hover {
    /* autoprefixer: off */
    background: linear-gradient(left, #1376f8, #53a4f4);
    /* autoprefixer: on */
    background: -o-linear-gradient(left, #1376f8, #53a4f4);
    background: -moz-linear-gradient(left, #1376f8, #53a4f4);
    background: -webkit-linear-gradient(left, #1376f8, #53a4f4);
  }

  .hover-blue:hover .banner-card-left>h2, .hover-blue:hover .rt>p, .hover-blue:hover .rt>p>span, .hover-blue:hover .banner-card-left>h2>span, .hover-blue:hover .banner-card-left>p, .hover-blue:hover .banner-card-right>span, .hover-blue:hover .banner-img-a>a, .hover-blue:hover .banner-card-right>p, .hover-blue:hover .banner-card-right>p>span {
    color: #fff !important;
  }

  // .hover-blue:hover .banner-img-a:before {
  //   background: url('/static/img/icon_ex_arrow.png') no-repeat -18px 0;
  // }

  .banner-img-a:before {
    content: '';
    background: url('/static/img/icon_ex_arrow.png') no-repeat -18px 0;
    width: 18px;
    height: 18px;
    position: absolute;
    top: 0px;
    left: 0;
    z-index: 1;
  }

  .banner-card {
    background-color: #fff;
    box-shadow: 0 8px 16px 0 rgba(31, 82, 173, 0.08);
    border-radius: 10px;
    margin-top: 10px;
    cursor: pointer;
  }

  .banner-mid {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    #banner-mid-l{
      background:-webkit-linear-gradient(left, #1376f8, #53a4f4);
      color:#fff;
       h2 {
          color: #fff;
        }

        p {
          color: #fff;
        }
        .banner .banner-img-a:before{
          display:block;
        }
        span{
           color: #fff;
        }
        .banner-img-a {
          a {
            color:#fff;
          }
        }
    }
    .banner-mid-left-card {
      width: 800px;
      height: 200px;
      display: flex;
      justify-content: space-around;
      position: relative;

      .banner-card-left {
        display: flex;
        flex-direction: column;
        align-items: self-start;
        height: 86%;
        justify-content: space-between;
        margin: auto 0;

        /* margin-left: 30px */
        h2 {
          font-size: 24px;
          font-weight: normal;
          color: #333;
        }

        p {
          width: 550px;
          color: #b3b3b3;
          word-break: break-all;
          text-align: justify;
          font-size: 14px;
        }

        .banner-img-a {
          position: relative;

          a {
            margin-left: 24px;
          }
        }
      }

      .banner-card-right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        height: 86%;
        justify-content: space-between;
        margin: auto 0;

        p {
          color: #1376f8;

          span {
            color: #333;
          }
        }
      }
    }
  }
}

/* 大事件 */
.event {
  height: 900px;
  width: 100%;
  background: url('/static/img/bg_honor.png') no-repeat 0 0;

  .event-container {
    display: flex;
    justify-content: space-around;
    margin-top: 16px;

    .event-common {
      ul {
        margin-top: 100px;

        li {
          width: 500px;

          /* margin 14px 0 */
          .event-title {
            width: 80px;
            height: 20px;
            background-color: #ffc619;
            border-radius: 4px;
            color: #fff;
            font-size: 14px;
          }

          .event-content {
            margin-top: 6px;
            font-size: 16px;
            color: #333;
            /* font-weight: bold */
            width: 100%;
            line-height: 30px;
            word-break: break-all;
            text-align: justify;

            span {
              color: #1376f8;
              width: 100%;
            }
          }

          .event-li-img {
            display: flex;
            align-items: center;

            img {
              width: 15px;
            }
          }

          .event-left-img {
            display: flex;

            /* justify-content: space-between */
            img {
              width: 220px;
            }
          }
        }
      }
    }

    .event-left {
      li {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .event-title {
          margin-right: 10px;
        }

        .event-li-img {
          width: 100%;
          margin-top: 6px;
        }
      }
    }
  }
}

/* 报名 */
.sign-float {
  ul {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;

    @keyframes floating {
      0% {
        transform: translateY(0);
      }

      50% {
        transform: translateY(20px);
      }

      100% {
        transform: translateY(0);
      }
    }

    /* li */
    /* animation: floating 3s ease infinite; */
    li:nth-child(odd) {
      margin-top: 140px;
      animation: floating 3s ease infinite;
    }

    li:nth-child(even) {
      animation: floating 4s ease infinite;
    }
  }
}

.mb-text {
  margin-bottom: 26px;
}

.sign-up {
  height: 600px;
  width: 100%;
  /* autoprefixer: off */
  background: linear-gradient(left, #1376f8, #53a4f4);
  /* autoprefixer: on */
  background: -o-linear-gradient(left, #1376f8, #53a4f4);
  background: -moz-linear-gradient(left, #1376f8, #53a4f4);
  background: -webkit-linear-gradient(left, #1376f8, #53a4f4);

  .sign-p {
    line-height: 30px;
    letter-spacing: 1.4px;
    color: #fff;
    margin-top: 15px;
  }

  .sign-btn-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    a {
      width: 150px;
      height: 50px;
      background-color: #ffffff;
      border-radius: 25px;
      margin: 0 10px;

      p {
        font-size: 14px;
        line-height: 50px;
        letter-spacing: 2.8px;
        color: #237fdb;
      }
    }
  }
}

/* 练习 */
.course {
  height: 663px;
  width: 100%;
  /* background-color #fafafa */
  background: url('/static/img/bg_course.png') no-repeat 80px 0;

  .course-more {
    text-align: center;
    margin-top: 30px;
    display: block;
    font-weight: bold;
  }

  .course-btn {
    padding-top: 80px;
  }

  .course-card-container {
    display: flex;
    justify-content: space-around;
    margin-top: 50px;

    .course-card:hover {
      margin-top: -20px;
      -webkit-transition: all 0.3s ease;
      -moz-transition: all 0.3s ease;
      -o-transition: all 0.3s ease;
      transition: all 0.3s ease;
    }

    .course-card {
      width: 350px;
      height: 305px;
      background-color: #ffffff;
      box-shadow: 0px 8px 16px 0px rgba(35, 127, 219, 0.08);
      border-radius: 5px;
      border: solid 1px #f1f1f1;
      cursor: pointer;

      .course-card-top {
        display: flex;
        align-items: center;
        margin-top: 40px;

        .course-card-top-btn {
          width: 50px;
          height: 50px;
          /* background-color: #1376f8; */
          font-size: 24px;
          color: #fff;
          font-weight: normal;
          line-height: 50px;
          text-align: center;
          border-radius: 50%;
          margin-left: 25px;
        }

        .course-card-title {
          letter-spacing: 2.6px;
          font-size: 26px;
          color: #333;
          margin-left: 30px;
        }
      }

      .course-card-content {
        margin-top: 50px;

        span {
          color: #3399ff;
          font-size: 14px;
          letter-spacing: 1.4px;
        }

        p {
          line-height: 30px;
          letter-spacing: 1.4px;
          color: #6d7787;
        }
      }
    }
  }

  .course-btn p {
    width: 100px;
    height: 35px;
    background-color: #c2e5ff;
    border-radius: 17.5px;
    font-family:"思源黑体";
    font-size: 16px;
    line-height: 34px;
    color: #1f52ad;
    display: block;
    text-align: center;
    margin: 0 auto;
    border: solid 1px #1376f8;
  }

  .course-p {
    font-size: 18px;
    color: #333333;
    margin-top: 20px;
  }
}

/* app */
.app-container {
  height: 600px;
  width: 100%;
  // background: url('/static/img/bg_app.png') no-repeat 0 0;
  background-color: #f0f8ff;

  .app-ul {
    display: flex;
    justify-content: space-around;

    /* margin-top 104px */
    li:nth-child(1) {
      width: 237px;

      span {
        font-size: 28px;
        color: #1376f8;
        display: block;
        text-align: initial;
      }

      p {
        font-size: 14px;
        color: #333;
        display: block;
        text-align: initial;
        font-weight: bold;
        margin-top: 10px;
        line-height: 30px;
        font-size: 16px;
      }
    }

    li:nth-child(3) {
      margin-top: 300px;

      p {
        text-align: left;
        font-weight: bold;
        line-height: 35px;
        font-size: 16px;
      }
    }
  }
}

/* 练习 */
.test-card-container {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;

  .card-img {
    img {
      cursor: pointer;
    }

    img:hover {
      margin-top: -20px;
      -webkit-transition: all 0.3s ease;
      -moz-transition: all 0.3s ease;
      -o-transition: all 0.3s ease;
      transition: all 0.3s ease;
    }
  }

  .test-card {
    width: 390px;
    height: 200px;
    background-color: #ffffff;
    box-shadow: 0px 8px 16px 0px rgba(31, 82, 173, 0.08);
    border-radius: 10px;
    cursor: pointer;
  }

  .test-card:hover {
    margin-top: -20px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }

  .card-top {
    display: flex;
    align-items: center;
    height: 100px;
    padding-top: 10px;
    position: relative;

    h2 {
      font-weight: normal;
      color: #333;
      margin-left: 10px;
    }

    .card-top-img {
      width: 84px;
      height: 84px;
      margin-left: 30px;
    }
  }

  .card-content {
    width: 80%;
    margin: 0 auto;
  }

  p {
    text-align: left;
    line-height: 24px;
    color: #808080;
  }
}

.test-more {
  float: right;
  padding-right: 20px;
  font-weight: bold;
}

/* 统计 */
.statistics-img {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 60px;
  margin-bottom: 20px;

  img {
    height: 300px;
    width: 400px;
  }
}

/* 媒体报道 */
.media-report {
  height: 300px;
}

.media-report-ul {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;

  li {
    margin-top: 10px;
    cursor: pointer;
  }

  li:hover {
    margin-top: -20px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
}

.new-panel-title1 {
  margin-top: 80px;
}

.new-panel {
  padding-top: 20px;
  background-color: #fafcfe;

  ul {
    padding-top: 20px;
    width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 200px 200px 200px 200px 200px 200px;
    grid-template-rows: 160px 160px 160px;

    li {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      img {
        height: 100px;
        width: 100px;
      }

      p {
        padding-top: 10px;
        font-size: 20px;
        color: #000;
      }
    }
  }
}

.new-panel-title {
  text-align: center;
  color: #000;
  font-size: 32px;
}

/* 顶尖教研-start */
.courses-panel-height {
  /* height: 745px; */
}

.teacher-minImg ul {
  display: flex;
  width: 100%;
}

.teacher-minImg ul li {
  width: 100%;
}

.courses-panel {
  margin-top: 40px;
  background: #fafcfe;
  height: 440px;
}

.courses-panel .containerIndex {
  position: relative;
  height: 440px;
}

.teacher-mainUrl {
  width: 341px;
  float: left;
  position: absolute;
  bottom: 0;
  left: -40px;
  /* display: none; */
}

.courses-teacher {
  margin-left: 37%;
  text-align: left;
}

.courses-teacher-name {
  width: 100%;
  height: 84px;
  border-bottom: 2px solid #b3b3b3;
  border-radius: 1px;
}

.courses-teacher .courses-teacher-name p {
  /* font-family:"思源黑体"; */
  font-size: 42px;
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #000000;
  float: left;
}

.courses-teacher .courses-teacher-name span {
  float: left;
  font-family:"思源黑体";
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 3.6px;
  color: #000000;
  margin: 33px 0 0 40px;
  display: block;
}

.courses-teacher .teacher-msg ul {
  margin-top: 3%;
  display: block;
  height: 35px;
}

.courses-teacher .teacher-msg ul li {
  width: 57px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 4px;
  font-family:"思源黑体";
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1.8px;
  color: #000000;
  margin-right: 20px;
  float: left;
}

.courses-teacher ul li.active {
  background-color: #332e36;
  color: #ffffff;
}

.courses-teacher .courses-teacher-content {
  margin-top: 10px;
  font-family:"思源黑体";
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 34px;
  letter-spacing: 0px;
  color: #000000;
}

.courses-teacher .courses-teacher-content span {
  display: block;
  height: 140px;
}

.courses-teacher .teacher-minImg {
  width: 100%;
  margin-top: 25px;
}

.courses-teacher .teacher-minImg ul li {
  position: relative;
  /* float: left; */
  /* width: 14%; */
  margin-bottom: 15px;
  box-sizing: border-box;
  margin-right: 2%;
}

.courses-teacher .teacher-minImg ul li:last-child {
  padding-right: 0;
}

.courses-teacher .teacher-minImg a {
  display: block;
  height: 120px;
  /* width:85px */
}

.teacher-minImg span {
  position: absolute;
  bottom: 0;
  text-align: center;
  width: 85px;
  font-size: 16px;
  color: #000;
}

.courses-teacher .teacher-minImg div {
  position: absolute;
  top: 0;
  left: 0;
}

.teacher-minImg a:hover .front, .teacher-minImg a:focus .front, .teacher-minImg li.cur .front {
  -webkit-transform: rotateY(180deg);
  -moz-transform: rotateY(180deg);
  -o-transform: rotateY(180deg);
  -ms-transform: rotateY(180deg);
}

.teacher-minImg .front {
  z-index: 2;
  -webkit-transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
  -webkit-transition: -webkit-transform 0.3s linear;
  -moz-transform-style: preserve-3d;
  -moz-backface-visibility: hidden;
  -moz-transition: -moz-transform 0.3s linear;
}

.teacher-minImg a:hover .back, .teacher-minImg a:focus .back, .teacher-minImg li.cur .back {
  z-index: 3;
  zoom: 1;
  -webkit-transform: rotateY(0deg);
  -moz-transform: rotateY(0deg);
  -o-transform: rotateY(0deg);
  -ms-transform: rotateY(0deg);
}

.teacher-minImg .back {
  z-index: 1;
  -webkit-transform: rotateY(-180deg);
  -webkit-transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
  -webkit-transition: -webkit-transform 0.3s linear;
  -moz-transform: rotateY(-180deg);
  -moz-transform-style: preserve-3d;
  -moz-backface-visibility: hidden;
  -moz-transition: -moz-transform 0.3s linear;
  -o-transform: rotateY(-180deg);
  -o-transform-style: preserve-3d;
  -o-backface-visibility: hidden;
  -o-transition: -o-transform 0.3s linear;
  -ms-transform: rotateY(-180deg);
  -ms-transform-style: preserve-3d;
  -ms-backface-visibility: hidden;
  -ms-transition: -ms-transform 0.3s linear;
}

.new-block {
  display: block;
}

.courese-Jnc {
  position: relative;
}

@media only screen and (max-width: 750px) and (min-width: 300px) {
  .swiper-banner {
    margin-top: 128px;
  }

  body, html {
    width: 100%;
    overflow: hidden;
  }

  .test {
    margin-top: auto !important;
  }

  .no-before-img {
    width: 14px !important;
  }

  .banner-img-a {
    display: flex;
    align-items: center;
  }

  .banner .banner-img-a:before {
    background-size: 30px !important;
    display:block;
  }

  .statistics-img {
    margin-top: 20px;
  }

  .new-panel-title {
    font-size: 18px;
    font-weight: normal;
  }

  .media-report {
    height: auto;
  }

  .statistics-img1 {
    width: 150px !important;
  }

  .statistics-img2 {
    width: 160px !important;
  }

  .statistics-img img {
    height: 110px;
    /* width 150px!important */
  }

  .banner .hover-blue:hover .banner-img-a[data-v-3bf6d6bb]:before {
    background: url('/static/img/icon_ex_arrow.png') no-repeat -14px 0;
  }

  .test-course {
    height: auto !important;
  }

  .container-content-width {
    width: auto;
  }

  .hot {
    height: 42px;
    width: 42px;
    right: -11px !important;
    top: -12px !important;
  }

  .media-card {
    width: 167px !important;
    height: 119px !important;

    h2 {
      font-size: 12px;
    }

    p {
      width: 144px !important;
      margin-bottom: 0 !important;
    }

    .new {
      width: 36px;
      height: 36px;
      right: -15px !important;
      top: -12px !important;
    }
  }

  .course {
    height: auto;

    .course-btn {
      padding-top: 30px;
    }

    .course-card-container {
      flex-wrap: wrap;
      margin-top: 0;

      .course-card {
        margin-top: 20px;
      }
    }
  }

  .app-container {
    height: auto;

    .app-ul {
      li {
        margin-top: 0 !important;

        span {
          font-size: 14px !important;
        }

        p {
          font-size: 12px !important;
        }
      }
    }
  }

  .banner-card {
    border-radius: 5px !important;
  }

  .container-title {
    font-size: 16px;
    margin-top: 20px;
  }

  .teacher-course {
    display: flex;
    flex-direction: row;

    .card-img {
      img {
        width: 142px;
        height: 180px;
      }
    }
  }

  .app-container {
    margin-top: 30px;
  }

  .sign-up {
    height: auto;

    .container-title {
      padding-top: 30px;
      margin-top: 0;
    }

    .sign-float {
      ul {
        margin-top: 10px;
        margin-bottom: 30px;

        @keyframes floating {
          0% {
            transform: translateY(0);
          }

          50% {
            transform: translateY(10px);
          }

          100% {
            transform: translateY(0);
          }
        }

        li:nth-child(odd) {
          margin-top: 60px;
          animation: floating 3s ease infinite;
        }

        li:nth-child(4) {
          margin-top: 30px !important;
        }

        li:nth-child(6) {
          margin-top: 70px !important;
        }

        li:nth-child(even) {
          /* margin-top 30px!important */
          animation: floating 4s ease infinite;
        }
      }
    }

    p {
      font-size: 12px;
    }
  }

  .app-bottom-text {
    display: flex;
    width: 90%;
    margin: 0 auto;
    margin-top: 20px;

    .app-bottom-text-l {
      p {
        width: 90%;
        line-height: 22px;
      }
    }

    div {
      width: 50%;

      span {
        font-size: 18px;
      }

      p {
        font-size: 12px;
      }
    }
  }

  .course-more {
    padding-bottom: 10px;
  }

  .media-report-ul {
    width: 90%;
    margin: 0 auto;
    margin-bottom: 20px;

    li {
      img {
        width: 92px;
        height: 36px;
      }
    }
  }

  .mb-text {
    margin-bottom: 0;
  }

  .courses-panel-height {
    margin-top: 0 !important;
  }

  .event {
    height: auto;
    background: #fff;

    .container-content {
      .container-content-width {
        // .event-container {
        // display: block;
      }
    }
  }

  .test-card-container {
    justify-content: center;
    margin-top: 0;
    flex-wrap: wrap;

    .test-card {
      width: 345px;
      height: 177px;
      margin-top: 20px;

      .card-top {
        h2 {
          font-size: 21px;
        }

        .card-top-img {
          height: 70px;
          width: 70px;
        }
      }

      .card-content {
        p {
          font-size: 12px;
          color: #808080;
          line-height: 28px;
        }
      }
    }
  }

  .exam-card {
    width: 345px !important;
    height: 120px !important;
    margin-bottom: 20px;

    .banner-card-top {
      height: 27px;
      line-height: 27px;

      h2 {
        font-size: 10px;
      }
    }

    ul {
      li {
        img {
          width: 21px;
          height: 21px;
        }

        p {
          font-size: 8px;
          width: 40px !important;
        }

        span {
          font-size: 6px;
          width: 60px;
        }

        i {
          line-height: 12px;
          width: 18px;
          height: 12px;
          font-size: 6px;
        }

        a {
          font-size: 8px;
        }
      }
    }
  }

  .tar {
    text-align: right !important;
  }

  .banner {
    margin-top: 104px !important;
    height: auto;

    .banner-bottom {
      flex-direction: row !important;
      flex-wrap: wrap;
    }

    .banner-top {
      .banner-top-top {
        align-items: center;
        width: 90%;
        margin: 0 auto;

        h2 {
          font-size: 14px;
        }
      }

      p {
        width: 300px;
        font-size: 11px;
      }
    }

    .banner-top {
      width: 80%;
      margin: 0 auto;
      padding-top: 40px;

      p {
        margin-left: 0;
        width: auto;
      }
    }

    #blue-card {
      width: 345px;
      height: 120px;
    }

    .banner-mid {
      align-items: center;
      flex-direction: column;
      justify-content: space-between;
      width: 345px;
      margin: 0 auto;

      .banner-mid-left-card {
        width: 345px;
        height: 120px;

        .banner-card-left {
          h2 {
            font-size: 14px !important;
            height: 20px;

            span {
              font-size: 12px !important;
              margin-left: 0 !important;
            }
          }

          p {
            width: 300px;
            font-size: 10px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
          }

          a {
            font-size: 11px !important;
          }
        }

        .banner-card-right {
          position: absolute;
          height: auto;
          right: 26px;

          p {
            text-align: right;
            font-size: 10px;
            width: 120px;
            margin-top: 8px;
          }

          .right-p2 {
            margin-top: 66px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1200px) and (min-width: 992px) {
  .courses-teacher .courses-teacher-name p {
    font-size: 40px;
  }

  .courses-teacher .courses-teacher-content {
    font-size: 16px;
  }

  .ielts-list-title {
    width: 98%;
    margin-left: 1%;
  }
}

@media only screen and (max-width: 991px) and (min-width: 300px) {
  /* .navbar-top .navbar-top-div { */
  /* margin-left: 5%; */
  /* } */
  /* .new-panel ul */
  .nav-label li {
    width: 80px;
    margin: 0 10px;
    font-size: 14px;
  }

  .container-list-chunk {
    width: 50%;
    /* margin-bottom: 2%; */
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px 0;
  }

  .container-list-chunk:nth-child(2) {
    margin-right: 0;
  }

  .ielts-list-title {
    width: 98%;
    margin-left: 1%;
  }

  .courses-teacher-name {
    width: 100%;
    height: 60px;
  }

  .courses-teacher .courses-teacher-name p {
    font-size: 30px;
  }

  .courses-teacher .courses-teacher-name span {
    font-size: 14px;
    margin: 3% 0 0 4%;
  }

  .courses-teacher {
    margin-left: 41%;
  }

  .courses-teacher .courses-teacher-content {
    font-size: 14px;
    line-height: 27px;
  }

  .Public-Reputation-height {
    /* height: 535px; */
  }

  .courses-panel-height {
    /* height: 630px; */
  }

  .courses-panel {
    margin-top: 100px;
    height: 390px;
  }

  .courses-panel .containerIndex {
    height: 390px;
  }

  .teacher-mainUrl {
    width: 290px;
    left: -45px;
  }

  .info-Jnc {
    right: -45px;
  }
}

@media only screen and (max-width: 800px) and (min-width: 300px) {
  .logo-div {
    width: 22%;
    margin-right: 10px;
  }

  .navbar-top, .navbar-top .navbar-top-div, .nav-label li {
    height: 40px;
    line-height: 40px;
  }

  .nav-label li {
    width: 80px;
    margin: 0 8px;
    font-size: 12px;
  }

  /* 顶尖教研-start */
  .courses-panel-height {
    /* height: 590px; */
  }

  .teacher-mainUrl {
    width: 30%;
    left: 0;
  }

  .courses-teacher {
    margin-left: 32%;
    top: -78px;
  }

  .courses-panel {
    margin-top: 95px;
    height: 300px;
  }

  .courses-panel .containerIndex {
    height: 300px;
  }

  .courses-teacher .teacher-minImg {
    width: 142%;
    margin-left: -42%;
    margin-top: 15px;
  }

  .courses-teacher .courses-teacher-name span {
    font-size: 12px;
    margin: 3% 0 0 3%;
    letter-spacing: 0;
  }

  .courses-teacher .courses-teacher-content {
    height: 162px;
    line-height: 25px;
  }

  .container-list-chunk .container-list-chunk-text {
    margin-left: 5px;
  }

  .info-Jnc {
    position: static;
  }

  /* 顶尖教研-end */
}

@media only screen and (max-width: 767px) and (min-width: 300px) {
  .container-all {
    width: 98%;
  }

  .container-list-chunk img {
    width: 20%;
  }

  .container-list-chunk .container-list-chunk-text p {
    font-size: 18px;
    margin: 0;
  }

  .container-list-chunk .container-list-chunk-text span {
    font-size: 12px;
    letter-spacing: 0;
  }

  .list-title {
    margin-left: 2%;
  }

  .Public-Reputation-height {
    /* height: 2650px; */
  }

  .Public-Reputation {
    width: 65%;
    display: block;
    margin: 0 auto;
    text-align: center;
    float: none;
    /* margin-top: 4%; */
  }

  .footer-panel a img {
    width: 90px;
  }

  .footer-panel a p {
    font-size: 16px;
  }

  .footer-panel-content {
    right: 0;
    bottom: 70px;
    width: 100%;
  }

  .FamousClasses-video a {
    width: 48%;
  }

  .ielts-list-title {
    height: 95px;
  }

  .ielts-list-title .ielts-list-float p i {
    font-size: 40px;
  }

  .ielts-list-title .ielts-list-float {
    height: 62px;
  }

  .ielts-list-title .ielts-list-float p {
    font-size: 22px;
    height: 62px;
  }

  .ielts-list-title .ielts-list-float span {
    left: 140px;
    font-size: 12px;
  }

  .ielts-list-title .ielts-list-float .span-Public {
    left: 165px;
  }

  .ielts-list-title .ielts-list-p {
    font-size: 14px;
  }
}

@media only screen and (max-width: 667px) and (min-width: 300px) {
  .new-panel-title {
    margin-top: 20px;
  }

  .teacher-on {
    height: 80px;
    width: 80px;
  }

  .teacher-minImg ul {
    padding-top: 30px;
  }

  .new-panel {
    margin-top: 80px;
  }

  .new-panel-title2 {
    padding-top: 50px;
  }

  .new-panel ul {
    padding-top: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;

    li {
      width: 33.3%;

      img {
        height: 60px;
        width: 60px;
      }

      p {
        padding-top: 0;
        font-size: 14px;
      }
    }

    .teacher-minImg ul {
      padding-top: 20px;
    }
  }

  .Public-Reputation-height {
    /* height: 1680px; */
  }

  /* 顶尖教研-start */
  .courses-panel {
    margin-top: 90px;
    height: 250px;
  }

  .courses-panel .containerIndex {
    height: 250px;
  }

  .courses-panel .containerIndex {
    padding-top: 1%;
  }

  .courses-teacher-name {
    height: 45px;
  }

  .courses-teacher .courses-teacher-name p {
    font-size: 22px;
  }

  .courses-teacher .teacher-msg ul li {
    width: 50px;
    height: 25px;
    line-height: 25px;
    font-size: 16px;
    letter-spacing: 1.2px;
    margin-right: 15px;
  }

  .courses-teacher .teacher-msg ul {
    height: 22px;
  }

  .courses-teacher .teacher-minImg {
    margin-top: 0;
  }

  .courses-panel-height {
    /* height: 520px; */
  }

  /* 顶尖教研-end */
}

@media only screen and (max-width: 475px) and (min-width: 300px) {
  .new-panel-title {
    margin-top: 20px;
  }

  .teacher-on {
    height: 80px;
    width: 80px;
  }

  .teacher-minImg ul {
    padding-top: 30px;
  }

  .new-panel {
    margin-top: 80px;
  }

  .new-panel-title2 {
    padding-top: 50px;
  }

  .new-panel ul {
    padding-top: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;

    li {
      width: 33.3%;

      img {
        height: 60px;
        width: 60px;
      }

      p {
        padding-top: 0;
        font-size: 14px;
      }
    }

    .teacher-minImg ul {
      padding-top: 20px;
    }
  }

  .Public-Reputation-height {
    /* height: 1680px; */
  }

  .textTitle {
    font-size: 20px;
  }

  .FamousClasses-video a {
    height: 150px;
    width: 48%;
  }

  /* 顶尖教研-start */
  .courses-teacher-name {
    height: 35px;
  }

  .courses-panel {
    margin-top: 60px;
    height: 185px;
  }

  .courses-panel .containerIndex {
    height: 185px;
  }

  .courses-teacher .courses-teacher-content span {
    display: inline;
  }

  .courses-teacher .courses-teacher-content {
    font-size: 12px;
    height: 110px;
    line-height: 20px;
    margin-top: 5px;
  }

  .courses-panel-height {
    /* height: 405px; */
  }

  .courses-teacher .courses-teacher-name p {
    font-size: 20px;
  }

  .courses-teacher .courses-teacher-name span {
    font-size: 10px;
    margin: 3% 0 0 3%;
    letter-spacing: 0;
    -webkit-transform-origin-x: 0;
    -webkit-transform: scale(0.9);
  }

  .courses-teacher .teacher-msg ul li {
    width: 45px;
    height: 22px;
    line-height: 22px;
    font-size: 14px;
    letter-spacing: 1px;
    margin-right: 15px;
  }

  .courses-teacher .teacher-minImg {
    margin-top: 10px;
  }

  /* 顶尖教研-end */
  .ielts-list-title {
    height: 80px;
  }

  .ielts-list-title .ielts-list-float p i {
    font-size: 32px;
  }

  .ielts-list-title .ielts-list-float {
    height: 52px;
  }

  .ielts-list-title .ielts-list-float p {
    font-size: 16px;
    height: 52px;
  }

  .ielts-list-title .ielts-list-float span {
    left: 110px;
    font-size: 10px;
  }

  .ielts-list-title .ielts-list-float .span-Public {
    left: 135px;
  }

  .ielts-list-title .ielts-list-p {
    font-size: 12px;
  }
}

@media only screen and (max-width: 425px) and (min-width: 300px) {
  .navbar-top .navbar-top-div {
    display: flex;
    justify-content: center;
  }

  .logo-div {
    margin-right: 2px;
  }

  .nav-label li {
    /* width: 55px; */
    margin: 0 6px;
    font-size: 12px;
  }

  .courses-panel {
    margin-top: 30px;
  }

  .courses-panel-height {
    /* height: 376px; */
  }

  .courses-teacher .teacher-msg ul {
    margin-top: 2%;
  }

  .courses-teacher .courses-teacher-name p {
    font-size: 18px;
  }

  .Public-Reputation-height {
    /* height: 1555px; */
  }
}

@media only screen and (max-width: 400px) and (min-width: 300px) {
  .footerBotton {
    font-size: 12px;
  }

  .container-list-chunk .container-list-chunk-text p {
    height: 25px;
  }

  .excellent-courses-content a {
    width: 46%;
    margin-left: 1%;
    margin-right: 1%;
  }

  .Public-Reputation-height {
    /* height: 1465px; */
  }

  #custom-group .custom-rtbtn {
    font-size: 12px;
  }

  #custom-group {
    bottom: 18%;
    width: 70px;
    height: 240px;
  }

  #custom-group .rtbtn .custom-content {
    right: 65px;
  }

  .courses-panel {
    margin-top: 40px;
    height: 180px;
  }

  .courses-teacher {
    margin-left: 29%;
  }

  .courses-teacher .teacher-minImg {
    width: 140%;
    margin-left: -37%;
  }

  .teacher-mainUrl {
    width: 28%;
    left: 0;
  }

  .teacher-on {
    height: 50px;
    width: 50px;
  }

  .teacher-minImg ul {
    padding-top: 30px;
  }

  .new-panel {
    margin-top: 20px;
  }

  .new-panel-title {
    margin-top: 20px;
  }

  .new-panel ul {
    padding-top: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;

    li {
      width: 33.3%;

      img {
        height: 60px;
        width: 60px;
      }

      p {
        padding-top: 0;
        font-size: 14px;
      }
    }

    .teacher-minImg ul {
      padding-top: 20px;
    }
  }

  .courses-teacher .courses-teacher-name p {
    font-size: 15px;
    line-height: 28px;
  }
}

.header-right-silde {
  width: 320px;
  height: 180px;
  background-color: #ffffff;
  border-radius: 8px;
  position: absolute;
  right: 0;
  top: 64px;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .silde-lef {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;

    img {
      height: 120px;
      width: 120px;
    }

    p {
      line-height: 12px;
      height: 12px;
      color: #333333;
      padding-top: 10px;
    }

    span {
      color: #1694e3;
      font-style: 12px;
      line-height: 12px;
      padding-top: 20px;
    }
  }
}

@media only screen and (max-width: 1024px) {
  .open-course, .quality-course {
    padding: 30px 0 !important;
  }

  .container-title {
    font-size: 18px !important;
  }

  .container-title-2 {
    font-size: 16px !important;
    margin-bottom: 10px !important;
  }

  .container-title-3 {
    font-size: 9px !important;
    width: 90%;
    margin: 0 auto;
  }

  .c-item {
    width: 48% !important;
    margin-bottom: 15px;
  }

  .c-more {
    font-size: 9px !important;
  }

  .c-name {
    font-size: 10px !important;
  }

  .c-title {
    width: 90%;
    text-align: center;
    font-size: 7px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .course-content {
    width: 90%;
  }

  .course-list {
    flex-wrap: wrap;
  }

  .card-img {
    width: 50%;
  }
}
</style>

<style scoped>
.banner_box li {
  background: url("/static/img/pic_appdownload_ielts.png") no-repeat right
    center;
  background-size: 700px;
  text-align: left;
  height: 505px;
  padding-left: 20px;
}

.banner_box li h2 {
  color: #1376f8;
  font-weight: normal;
}

.banner_box li .title {
  color: #333333;
  width: 461px;
  margin-top: 10px;
  font-size: 16px;
}

.banner_box li .con-box {
  width: 480px;
  height: 120px;
  background-color: #1376f8;
  border-radius: 10px;
  opacity: 0.65;
  /* text-align: center; */
  margin: 32px 0;
  padding-top: 15px;
  padding-left: 12px;
}

.banner_box li .con-box p {
  color: #fff;
  font-size: 16px;
  line-height: 30px;
}

.banner_box li .bottom {
  display: flex;
}

.banner_box li .bottom .img {
  width: 235px;
  height: 40px;
  cursor: pointer;
}

.banner_box li .bottom a {
  width: 160px;
  height: 40px;
  background-color: #1376f8;
  border-radius: 20px;
  line-height: 40px;
  color: #fff;
  margin-left: 20px;
  padding-left: 30px;
  font-size: 18px;
}

.banner_box li .bottom a img {
  width: 9px;
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/Home.vue